import {
  GET_ATTACHMENT_CATEGORY_TYPE_DATA,
  GET_ATTACHMENT_CATEGORY_TYPE_DATA_SUCCESS,
  GET_ATTACHMENT_CATEGORY_TYPE_DATA_FAIL,
  ADD_ATTACHMENT_CATEGORY_TYPE,
  ADD_ATTACHMENT_CATEGORY_TYPE_SUCCESS,
  ADD_ATTACHMENT_CATEGORY_TYPE_FAIL,
  DELETE_ATTACHMENT_CATEGORY_TYPE,
  DELETE_ATTACHMENT_CATEGORY_TYPE_SUCCESS,
  DELETE_ATTACHMENT_CATEGORY_TYPE_FAIL,
  UPDATE_ATTACHMENT_CATEGORY_TYPE,
  UPDATE_ATTACHMENT_CATEGORY_TYPE_SUCCESS,
  UPDATE_ATTACHMENT_CATEGORY_TYPE_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  attachmentCategoryTypeList: [],
  attachmentCategoryTypeCreateSuccess: [],
  attachmentCategoryTypeDelete: [],
  attachmentCategoryTypeUpdate: [],
  loading: false,
};

const AttachmentCategoryType = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ATTACHMENT_CATEGORY_TYPE_DATA:
      return { ...state, loading: true };

    case GET_ATTACHMENT_CATEGORY_TYPE_DATA_SUCCESS:
      return {
        ...state,
        attachmentCategoryTypeList: action.payload,
        loading: false,
      };
    case GET_ATTACHMENT_CATEGORY_TYPE_DATA_FAIL:
      return {
        ...state,
        attachmentCategoryTypeList: [],
        loading: false,
      };

    case ADD_ATTACHMENT_CATEGORY_TYPE:
      return {
        ...state,
      };
    case ADD_ATTACHMENT_CATEGORY_TYPE_SUCCESS:
      return {
        ...state,
        attachmentCategoryTypeCreateSuccess: action.payload,
      };
    case ADD_ATTACHMENT_CATEGORY_TYPE_FAIL:
      return {
        ...state,
        attachmentCategoryTypeCreateSuccess: action.payload,
      };

    case DELETE_ATTACHMENT_CATEGORY_TYPE:
      return {
        ...state,
      };

    case DELETE_ATTACHMENT_CATEGORY_TYPE_SUCCESS:
      return {
        ...state,
        attachmentCategoryTypeDelete: action.payload,
      };

    case DELETE_ATTACHMENT_CATEGORY_TYPE_FAIL:
      return {
        ...state,
        attachmentCategoryTypeDelete: action.payload,
      };

    case UPDATE_ATTACHMENT_CATEGORY_TYPE:
      return {
        ...state,
      };

    case UPDATE_ATTACHMENT_CATEGORY_TYPE_SUCCESS:
      return {
        ...state,
        attachmentCategoryTypeUpdate: action.payload,
      };

    case UPDATE_ATTACHMENT_CATEGORY_TYPE_FAIL:
      return {
        ...state,
        attachmentCategoryTypeUpdate: action.payload,
      };

    default:
      return state;
  }
};

export default AttachmentCategoryType;
